import { render, staticRenderFns } from "./Searchkeywordsmanage.vue?vue&type=template&id=65b30918&scoped=true&"
import script from "./Searchkeywordsmanage.vue?vue&type=script&lang=js&"
export * from "./Searchkeywordsmanage.vue?vue&type=script&lang=js&"
import style0 from "./Searchkeywordsmanage.vue?vue&type=style&index=0&id=65b30918&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b30918",
  null
  
)

export default component.exports